export const normalizeEditableNumericValue = (
  value,
  { allowDecimal = true } = {}
) => {
  if (value === '') {
    return { displayValue: '', numericValue: null };
  }

  if (typeof value !== 'string') {
    const numericValue = Number(value);
    return {
      displayValue: Number.isFinite(numericValue) ? String(numericValue) : '',
      numericValue: Number.isFinite(numericValue) ? numericValue : null,
    };
  }

  const trimmedValue = value.trim();

  if (!trimmedValue) {
    return { displayValue: '', numericValue: null };
  }

  const hasDecimal = trimmedValue.includes('.');

  if (allowDecimal && /^-?\d*(\.\d*)?$/.test(trimmedValue)) {
    return {
      displayValue: trimmedValue,
      numericValue: Number(trimmedValue),
    };
  }

  if (!allowDecimal && /^-?\d+$/.test(trimmedValue)) {
    return {
      displayValue: trimmedValue,
      numericValue: Number(trimmedValue),
    };
  }

  return {
    displayValue: trimmedValue,
    numericValue: Number.isFinite(Number(trimmedValue))
      ? Number(trimmedValue)
      : null,
  };
};
